import { render, staticRenderFns } from "./sustancias-quimicas.vue?vue&type=template&id=14787a2a&"
import script from "./sustancias-quimicas.vue?vue&type=script&lang=js&"
export * from "./sustancias-quimicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports